export enum LoanNoteApiPath {
  CMS = "cms/content/loan-note",
  Series = "trades/series/nominee",
  Organisation = "trades/client",
  LoanNote = "trades/series/loan-note",
  LoanNoteTypes = "trades/series/loan-note/types",
}
